export default "__VITE_ASSET__Danr38af__"